/**
 * @desc allocationLogisticsReturn
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.BatchMasterCreateRequestParamDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/allocation/returned`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
